import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConnectService {

constructor(private httpclient: HttpClient) { }
 getProfileSnapshot(userId) {
     return this.httpclient.get(`UserRoleViews/profile-snapshot?userId=${userId}`);
 }
 connectUser(connectUserId) {
  return this.httpclient.post(`ConnectedUsers/connect?connectUserId=${connectUserId}`,'');
 }
 getReuestedList(search){
     return this.httpclient.get(`ConnectedUsers/connect-request?search=${search}`);
 }
 getMyConnectionList(status,search) {
  return this.httpclient.get(`ConnectedUsers/connections?status=${status}&search=${search}`);
 }
 updateConnectionStatus(connectionId,status) {
     return this.httpclient.patch(`ConnectedUsers/connection-status-change/${connectionId}?status=${status}`,{});
 }
 withdrawConnection(connectionId) {
     return this.httpclient.patch(`ConnectedUsers/withdraw-connection-request/${connectionId}`,{})
 }
 createGroup(receiverId){
     return this.httpclient.post(`MessageGroups/create-group/${receiverId}`,{})
 }
 getGroupList(){
     return this.httpclient.get(`MessageGroups/groups`);
 }
 postMessage(recipientGroupId,receiverId,data){
     return this.httpclient.post(`Messages/sent/${recipientGroupId}?receiverId=${receiverId}`,data);
 }
 getMessages(recipientGroupId,receiverId){
  return this.httpclient.get(`Messages/messages/${recipientGroupId}?receiverId=${receiverId}`)
 }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/connect.service.ts